import { Icon, Text, VStack } from '@chakra-ui/react';
import { FaRunning } from 'react-icons/fa';

import { JournalEntryCard } from '../JournalEntryCard/JournalEntryCard';
import { ActivityJournalEntry } from '../types';

export interface ActivityEntryCardProps {
  entry: ActivityJournalEntry;
}

/**
 * Displays an activity journal entry with value, unit, and comments.
 */
export const ActivityEntryCard: React.FC<ActivityEntryCardProps> = ({
  entry,
}) => {
  const hasValue = entry.value !== null && entry.value !== undefined;

  return (
    <JournalEntryCard
      entryId={entry.id}
      icon={<Icon as={FaRunning} color="green.500" boxSize={5} />}
      title={
        <Text fontSize="sm" fontWeight={600} color="text.default">
          Activity
        </Text>
      }
      time={entry.createdAt}
      timezone={entry.timezone}
      comments={entry.comments}
    >
      {({ isExpanded: expanded }) => (
        <VStack align="stretch" spacing={2}>
          {hasValue && (
            <Text fontSize="lg" fontWeight={600} color="green.600">
              {entry.value} {entry.unit}
            </Text>
          )}

          {expanded && entry.description && (
            <Text fontSize="sm" color="text.default">
              {entry.description}
            </Text>
          )}
        </VStack>
      )}
    </JournalEntryCard>
  );
};

ActivityEntryCard.displayName = 'ActivityEntryCard';
